import { axiosInstance, type CustomResponseFormat } from "api/instance";
import type { TaskEditorState } from "pages/task-editor/taskEditorUtils";

const DOMAIN = "ai/task-editor";

export type TaskEditorAIGenerateStatus =
  | "pending"
  | "processing"
  | "completed"
  | "failed";

export interface TaskEditorAIGenerateRequest {
  rawText: string;
  additionalInstructions?: string;
  previousResult?: TaskEditorState;
}

export interface TaskEditorAIGenerateResponse {
  requestId: string;
}

export interface TaskEditorAIStatusResponse {
  status: TaskEditorAIGenerateStatus;
  progress?: number;
  errorMessage?: string;
}

export type TaskEditorAIResultResponse = TaskEditorState;

export const taskEditorAiApi = {
  /** 생성 요청. requestId를 반환. */
  generate: (data: TaskEditorAIGenerateRequest) =>
    axiosInstance.post<CustomResponseFormat<TaskEditorAIGenerateResponse>>(
      `${DOMAIN}/generate`,
      data
    ),

  /** 생성 상태 조회 (polling). */
  getStatus: (requestId: string) =>
    axiosInstance.get<CustomResponseFormat<TaskEditorAIStatusResponse>>(
      `${DOMAIN}/status`,
      { params: { requestId } }
    ),

  /** 생성 결과 조회. completed 상태일 때만 호출. */
  getResult: (requestId: string) =>
    axiosInstance.get<CustomResponseFormat<TaskEditorAIResultResponse>>(
      `${DOMAIN}/result`,
      { params: { requestId } }
    ),
};
